module.exports = __webpack_public_path__ + "media/images/logo/payment_channel/qris_client-7f92db24ce96826a19f938852b993841.png";